module.exports = __webpack_public_path__ + "static/media/8.aeb3508e.svg";